import React from 'react'
import { ReactComponent as Plus } from '../assets/icons/plus.svg';

export const header = [
  {
    id: 1,
    name: 'MENTOR ISMI',
    position: 'left',
    width: {
      desktop: 320,
      tablet: 250,
      mobile: 200
    }
  },
  {
    id: 2,
    name: "O'QUVCHI",
    position: 'center',
    width: {
      desktop: 125,
      tablet: 90,
      mobile: 50
    }
  },
  {
    id: 3,
    name: 'KURSLAR',
    position: 'center',
    width: {
      desktop: 130,
      tablet: 100,
      mobile: 70
    }
  },
  {
    id: 4,
    name: 'DAROMAD',
    position: 'center',
    width: {
      desktop: 135,
      tablet: 106,
      mobile: 86
    }
  },
  {
    id: 5,
    name: 'BERILDI',
    position: 'center',
    width: {
      desktop: 110,
      tablet: 80,
      mobile: 60
    },
    color: '#00B533'
  },
  {
    id: 6,
    name: 'QOLDI',
    position: 'center',
    width: {
      desktop: 50,
      tablet: 40,
      mobile: 30
    },
    color: '#DE1E3A'
  },
  {
    id: 7,
    name: '',
    position: 'center',
    width: {
      desktop: 120,
      tablet: 100,
      mobile: 80
    }
  }
];
export const list = [];
export const align = header.map((item) => list.push(item.position));


export const tableData = [
  {
    id: 1, name: 'Sardorbek Muhtorov', student: '300 ta', courses: '3 ta', benefit: '8,000,000', given: '5,300,000', reminder: '3,000,000', Icon: <Plus />
  },
  {
    id: 2, name: 'Sardorbek Muhtorov', student: '300 ta', courses: '3 ta', benefit: '8,000,000', given: '5,300,000', reminder: '3,000,000', Icon: <Plus />
  },
  {
    id: 3, name: 'Sardorbek Muhtorov', student: '300 ta', courses: '3 ta', benefit: '8,000,000', given: '5,300,000', reminder: '3,000,000', Icon: <Plus />
  },
  {
    id: 4, name: 'Sardorbek Muhtorov', student: '300 ta', courses: '3 ta', benefit: '8,000,000', given: '5,300,000', reminder: '3,000,000', Icon: <Plus />
  },
  {
    id: 5, name: 'Sardorbek Muhtorov', student: '300 ta', courses: '3 ta', benefit: '8,000,000', given: '5,300,000', reminder: '3,000,000', Icon: <Plus />
  },
  {
    id: 6, name: 'Sardorbek Muhtorov tt', student: '300 ta', courses: '3 ta', benefit: '8,000,000', given: '5,300,000', reminder: '3,000,000', Icon: <Plus />, child: [
      { id: 61, name: 'Sardorbek Muhtorov', student: '300 ta', courses: '3 ta', benefit: '8,000,000', given: '5,300,000', reminder: '3,000,000' }, { id: 62, name: 'Sardorbek Muhtorov', student: '300 ta', courses: '3 ta', benefit: '8,000,000', given: '5,300,000', reminder: '3,000,000' }, { id: 63, name: 'Sardorbek Muhtorov', student: '300 ta', courses: '3 ta', benefit: '8,000,000', given: '5,300,000', reminder: '3,000,000' }, { id: 64, name: 'Sardorbek Muhtorov', student: '300 ta', courses: '3 ta', benefit: '8,000,000', given: '5,300,000', reminder: '3,000,000' }
    ]
  },
  {
    id: 7, name: 'Sardorbek Muhtorov', student: '300 ta', courses: '3 ta', benefit: '8,000,000', given: '5,300,000', reminder: '3,000,000', Icon: <Plus />
  }, {
    id: 8, name: 'Sardorbek Muhtorov', student: '300 ta', courses: '3 ta', benefit: '8,000,000', given: '5,300,000', reminder: '3,000,000', Icon: <Plus />
  },];

export const total = {
  id: 9, name: 'Jami summa', student: '620', courses: '6', benefit: '14,600,000', given: '8,300,000', reminder: '5,000,000'
}






export const common = { name: "Sardorbek Muhtorov", age: 26, address: "Namangan, Uzbekistan", status: 'Student', nickname: 'Ali', univ: "sejong", job: 'developer' }
export const header1 = [
  { title: "ID", dataIndex: 'id', key: 'id' },
  { title: "Name", dataIndex: 'name', key: 'name' },
  { title: "Age", dataIndex: 'age', key: 'age' },
  { title: "Address", dataIndex: 'address', key: 'address' },
  { title: "Status", dataIndex: 'status', key: 'status' },
  { title: "Nickname", dataIndex: 'nickname', key: 'nickname' },
  { title: "Univ", dataIndex: 'univ', key: 'univ' },
  { title: "Job", dataIndex: 'job', key: 'job' },
]
export const sourceData1 = [
  { id: 1, ...common },
  { id: 2, ...common },
  { id: 3, ...common },
  { id: 4, ...common },
  { id: 5, ...common },
]

export const sourceData2 = [
  { id: 1, ...common },
  { id: 2, ...common },
  { id: 3, ...common },
  { id: 4, ...common },
  { id: 5, ...common },
  { id: 6, ...common },
  { id: 7, ...common },
  { id: 8, ...common },
  { id: 9, ...common },
  { id: 10, ...common },
  { id: 11, ...common },
  { id: 12, ...common },
  { id: 13, ...common },
  { id: 14, ...common },
  { id: 15, ...common },
  { id: 16, ...common },
  { id: 17, ...common },
  { id: 19, ...common },
  { id: 20, ...common },
  { id: 21, ...common },
  { id: 22, ...common },
  { id: 23, ...common },
  { id: 24, ...common },
]